import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const fontFamily =
  'PlusJakarta,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      labels: {
        font: {
          family: fontFamily,
        },
      },
    },
  },
  animation: {
    duration: 0,
  },
  datasets: {
    bar: {
      barPercentage: 1.0,
    },
  },
  scales: {
    x: {
      ticks: {
        font: {
          family: fontFamily,
        },
      },
      grid: {
        display: false,
      },
    },
    y: {
      ticks: {
        font: {
          family: fontFamily,
        },
        beginAtZero: true,
      },
      grid: {
        display: false,
      },
    },
  },
};

export default {
  name: 'BarChart',
  components: {
    Bar,
  },
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedOptions() {
      return {
        ...defaultChartOptions,
        ...this.chartOptions,
      };
    },
  },
  template: '<Bar :data=\"collection\" :options=\"mergedOptions\" />',
};
